// @flow
import * as React from 'react';
import Box from 'components/Box';
import Icon from 'components/Icon';
import Text from 'components/Text';
import { RouterLink } from 'components/Link';

type Link = {
  title: React.Node,
  to?: string | { pathname: string, state: Object }
};

const Breadcrumbs = ({ links, ...props }: { links: Array<Link> }) => (
  <Box
    component={Text}
    styleAs="bodySmall"
    display="flex"
    alignItems="center"
    data-qa-id="breadcrumbs"
    whiteSpace="nowrap"
    overflow="hidden"
    textOverflow="ellipsis"
    {...props}
  >
    {links.map(({ title, to, ...linkProps }, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <React.Fragment key={index}>
        {index > 0 && (
          <Box mx={10}>
            <Icon name="chevron" width={11} direction="left" display="block" />
          </Box>
        )}
        <Box
          component={to ? RouterLink : undefined}
          to={to || undefined}
          maxWidth={[
            `calc((100% - ${31 * (links.length - 0.5)}px) / ${links.length -
              1})`,
            null,
            'none'
          ]}
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          {...linkProps}
        >
          {index < links.length - 1 ? (
            title
          ) : (
            <>
              <Box display={['none', null, 'inline']}>{title}</Box>
              <Box display={['inline', null, 'none']}>
                <Box dangerouslySetInnerHTML={{ __html: '&hellip;' }} />
              </Box>
            </>
          )}
        </Box>
      </React.Fragment>
    ))}
  </Box>
);

export default Breadcrumbs;
